import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	timeStamp: null,
	loading: false,
	loadingAddress: false,
	loadingCreate: false,
	loadingUpdate: false,
	loadingDelete: false,
	mapLoading: false,
	sitesLoadingComplete: false,
	error: null
};

const sitesSlice = createSlice({
	name: 'sites',
	initialState,
	reducers: {
		loadSites(state) {
			state.loading = true;
			state.error = null;
		},
		loadSitesSuccess(state, action) {
			state.timeStamp = Date.now();
			state.loading = false;
			const orgID = action.payload.orgID;
			const oldSitesData = state.data[orgID] || [];

			// Merge sites data using 'siteID' as the unique identifier
			state.data[orgID] = mergeReduxStateData(oldSitesData, action.payload.data, 'siteID');

			state.sitesLoadingComplete = true;
		},
		loadSiteAddress(state) {
			state.loadingAddress = true;
			state.error = null;
		},
		loadSiteAddressSuccess(state, action) {
			state.data[action.payload.orgID] = state.data[action.payload.orgID].map((site) =>
				site.siteID === action.payload.siteID
					? { ...site, address: { data: action.payload.data, timeStamp: Date.now() } }
					: site
			);
			state.loadingAddress = false;
		},
		loadSiteAddressError(state, action) {
			state.error = action.payload;
			state.loadingAddress = false;
		},
		loadSitesError(state, action) {
			state.error = action.payload;
			state.loading = false;
		},
		createSite(state) {
			state.loadingCreate = true;
			state.error = null;
		},
		createSiteSuccess(state) {
			state.loadingCreate = false;
		},
		createSiteError(state, action) {
			state.error = action.payload;
			state.loadingCreate = false;
		},
		updateSite(state) {
			state.loadingUpdate = true;
			state.error = null;
		},
		updateSiteSuccess(state) {
			state.loadingUpdate = false;
		},
		updateSiteError(state, action) {
			state.error = action.payload;
			state.loadingUpdate = false;
		},
		deleteSite(state) {
			state.loadingDelete = true;
			state.error = null;
		},
		deleteSiteSuccess(state) {
			state.loadingDelete = false;
		},
		deleteSiteError(state, action) {
			state.error = action.payload;
			state.loadingDelete = false;
		},
		loadSiteMap: (state) => {
			state.mapLoading = true;
			state.error = null;
		},
		loadSiteMapSuccess: (state, action) => {
			state.mapLoading = false;
			state.data[action.payload.orgID] = state.data[action.payload.orgID].map((site) =>
				site.siteID === action.payload.siteID
					? { ...site, map: { data: action.payload.data, timeStamp: Date.now() } }
					: site
			);
		},
		loadSiteMapError: (state, action) => {
			state.mapLoading = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => initialState);
	}
});

export const sitesActions = sitesSlice.actions;
export default sitesSlice.reducer;
